import Car from "@src/interfaces/carDetails.interface";
import { ProfileSeller } from "@entities/profile";

export interface ProductContactCardProps {
    offer: Car;
    sellerData?: ProfileSeller;
}

export const MIGTORG_URL = "https://www.migtorg.com/";